import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Flex,
  Grid,
  GridItem,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { NumericFormat } from "react-number-format";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import { ITopCourses, TrafficData } from "../../models/admin/topCourses.model";
import ReportsService from "../../services/admin/reports.service";

const AdminReports = () => {
  const [operation, setOperationTypes] = useState("");
  const [loading, setLoading] = useState(true);
  const [byenrolments, setByEnrolments] = useState<ITopCourses[]>();
  const [byrevenue, setByRevenue] = useState<ITopCourses[]>();
  const [byrating, setByRating] = useState<ITopCourses[]>();
  const [currentFilter, setCurrentFilter] = useState<ITopCourses[]>();
  const [trafficconditionPiechartData, setTrafficConditionPiechartData] =
    useState<any[]>([]);
  // const [trafficData, setTrafficData] = useState<any[]>([]);
  const [trafficData, setTrafficData] = useState<TrafficData>({
    cityData: {},
    allUsers: 0,
    averageEnagegementDuration: "",
  });

  useEffect(() => {
    ReportsService.getCourseByEnrolment()
      .then((response) => {
        setCurrentFilter(response.data);
        setByEnrolments(response.data);
        setLoading(false);
      })
      .catch((err) => err);
    ReportsService.getCourseByRating()
      .then((response) => {
        setByRating(response.data);
      })
      .catch((err) => err);

    ReportsService.getCourseByRevenue()
      .then((response) => {
        setByRevenue(response.data);
      })
      .catch((err) => err);

    ReportsService.getTraffic().then((res: any) => {
      const trafficDT = res;

      setTrafficData(trafficDT);
      const allUsers = res.allUsers; // Access the total users directly

      const cityData = res.cityData;

      // Aggregate active users from each city
      let totalActiveUsers = 0;
      for (const city in cityData) {
        totalActiveUsers += parseInt(cityData[city].activeUsers);
      }

      const formattedData = [
        ["Category", "Value", { role: "style" }],
        ["Total Visits", allUsers, "color: #EC3337"], // Specify color for Total Visits slice
        ["Active Visitors", totalActiveUsers, "color: #579956"], // Specify color for Active Visitors slice
      ];

      // Update the state with the formatted data
      setTrafficConditionPiechartData(formattedData);
    });
  }, []);

  const traffic_condition_options_piechart = {
    // title: "Overall Traffic",
    // subtitle: "Visits in the past 365 days",
    pieHole: 0.6,
    is3D: false,
  };

  function updateOperation(operation_type: string): void {
    if (operation_type === "enrolment") {
      setOperationTypes("enrolment");
      setCurrentFilter(byenrolments);
    } else if (operation_type === "rating") {
      setOperationTypes("rating");
      setCurrentFilter(byrating);
    } else if (operation_type === "revenue") {
      setOperationTypes("revenue");
      setCurrentFilter(byrevenue);
    }
  }

  const data = [
    {
      name: "Bolaji",
      count: 10,
    },
    {
      name: "Femi",
      count: 8,
    },
    {
      name: "Josh",
      count: 7,
    },
    {
      name: "Abraham",
      count: 7,
    },
    {
      name: "Nike",
      count: 5,
    },
    {
      name: "Dorcas",
      count: 5,
    },
    {
      name: "Seun",
      count: 4,
    },
    {
      name: "Kuti",
      count: 4,
    },
    {
      name: "Daniel",
      count: 3,
    },
  ];

  const data2 = [
    {
      name: "Jan",
      uv: 40,

      amt: 2400,
    },
    {
      name: "Feb",
      uv: 20,

      amt: 2210,
    },
    {
      name: "Mar",
      uv: 25,

      amt: 2290,
    },
    {
      name: "Apr",
      uv: 50,

      amt: 2000,
    },
    {
      name: "May",
      uv: 10,

      amt: 2181,
    },
    {
      name: "Jun",
      uv: 100,

      amt: 2500,
    },
    {
      name: "Jul",
      uv: 32,

      amt: 2100,
    },
    {
      name: "Aug",
      uv: 70,

      amt: 2000,
    },
    {
      name: "Sep",
      uv: 52,

      amt: 2181,
    },
    {
      name: "Oct",
      uv: 35,

      amt: 2500,
    },
    {
      name: "Nov",
      uv: 79,

      amt: 2100,
    },
    {
      name: "Dec",
      uv: 50,

      amt: 2100,
    },
  ];

  const cityDataArray = Object.keys(trafficData.cityData).map((cityName) => ({
    city: cityName,
    totalUsers: trafficData.cityData[cityName].totalUsers,
    averageEngagementTime: trafficData.cityData[cityName].averageEngagementTime,
  }));
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              py="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Reports
                </Box>
              </Flex>
              <Tabs colorScheme="red">
                <TabList>
                  <Tab>Revenue</Tab>
                  <Tab>Traffic</Tab>
                </TabList>

                <TabPanels>
                  <TabPanel>
                    <Flex
                      justifyContent="space-between"
                      pb="20px"
                      mb="20px"
                      maxWidth={"100%"}
                      overflowX={"scroll"}
                      className="scroll-hidden"
                    >
                      <Container
                        bg="white"
                        borderRadius="10px"
                        px={10}
                        py={8}
                        boxShadow="base"
                        m={0}
                        minWidth={"200px"}
                      >
                        <VStack pb={3} pt={1}>
                          <Text color="#959595" fontSize={13}>
                            Total Revenue
                          </Text>
                          <Text
                            color="#353535"
                            fontWeight="semibold"
                            fontSize={30}
                          >
                            ₦20M
                          </Text>
                        </VStack>
                      </Container>

                      <Spacer mx={3} />
                      <Container
                        bg="white"
                        borderRadius="10px"
                        px={10}
                        py={8}
                        boxShadow="base"
                        m={0}
                        minWidth={"200px"}
                      >
                        <VStack pb={3} pt={1}>
                          <Text color="#959595" fontSize="14px">
                            Total Sales
                          </Text>
                          <Text
                            color="#353535"
                            fontWeight="semibold"
                            fontSize={30}
                          >
                            ₦5M
                          </Text>
                        </VStack>
                      </Container>

                      <Spacer mx={3} />
                      <Container
                        px={10}
                        py={8}
                        borderRadius="10px"
                        boxShadow="base"
                        bg="white"
                        m={0}
                        minWidth={"200px"}
                      >
                        <VStack pb={3} pt={1}>
                          <HStack spacing={3}>
                            <Text color="#959595" fontSize="14px">
                              This Month
                            </Text>
                          </HStack>
                          <Text
                            color="#353535"
                            fontWeight="semibold"
                            fontSize={30}
                          >
                            ₦960K
                          </Text>
                        </VStack>
                      </Container>

                      <Spacer mx={3} />

                      <Container
                        px={10}
                        py={8}
                        borderRadius="10px"
                        boxShadow="base"
                        bg="white"
                        m={0}
                        minWidth={"200px"}
                      >
                        <VStack pb={3} pt={1}>
                          <Text color="#959595" fontSize="14px">
                            {" "}
                            Total Withdrawal
                          </Text>
                          <Text
                            color="#353535"
                            fontWeight="semibold"
                            fontSize={30}
                          >
                            ₦1.2M
                          </Text>
                        </VStack>
                      </Container>
                    </Flex>

                    <Flex
                      justifyContent="space-between"
                      mt="20px"
                      flexDirection={["column", "column", "column", "row"]}
                      gap="1rem"
                    >
                      <Box
                        bg="white"
                        px="20px"
                        width={["100%", "100%", "100%", "60%"]}
                        boxShadow={"sm"}
                      >
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          py="26px"
                        >
                          <Box color="#2B2B2B" fontWeight="800" fontSize="22px">
                            Course Sales
                          </Box>

                          <HStack>
                            <Menu>
                              <MenuButton
                                as={Button}
                                // leftIcon={<US title="Nigeria" />}
                                bg="whiteAlpha.200"
                                color="#616161"
                                variant={"outline"}
                                size="sm"
                                fontSize={13}
                                width="106px"
                                border="1px solid"
                                borderColor="#9E9E9E"
                              >
                                2022/2023
                              </MenuButton>
                              <MenuList fontSize={12}>
                                <MenuItem>2022/2023</MenuItem>

                                <MenuItem>2021/2022</MenuItem>
                                <MenuItem> 2020/2021</MenuItem>
                                <MenuItem>2019/2020</MenuItem>
                              </MenuList>
                            </Menu>
                          </HStack>
                        </Flex>
                        <Box height="300px" width="100%">
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart
                              width={500}
                              height={300}
                              data={data2}
                              margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                              }}
                            >
                              <CartesianGrid strokeDasharray="0 2" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Line
                                type="monotone"
                                dataKey="uv"
                                stroke="#EC3337"
                              />
                            </LineChart>
                          </ResponsiveContainer>
                        </Box>
                      </Box>
                      <Box
                        bg="white"
                        px="20px"
                        width={["100%", "100%", "100%", "40%"]}
                        boxShadow={"sm"}
                      >
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          py="26px"
                        >
                          <Box color="#2B2B2B" fontWeight="800" fontSize="22px">
                            Top Courses
                          </Box>

                          <Menu>
                            <MenuButton
                              as={Button}
                              rightIcon={<ChevronDownIcon />}
                              colorScheme="##7883A7"
                              variant={"outline"}
                              size="sm"
                              fontSize={12}
                            >
                              {operation === "enrolment"
                                ? "By Enrolment"
                                : operation === "revenue"
                                ? "By Revenue"
                                : operation === "rating"
                                ? "By Rating"
                                : operation === "trainees"
                                ? "By Trainees"
                                : "By Enrolment"}
                            </MenuButton>
                            <MenuList fontSize={12}>
                              <MenuItem
                                onClick={() => updateOperation("enrolment")}
                              >
                                By Enrolment
                              </MenuItem>

                              <MenuItem
                                onClick={() => updateOperation("revenue")}
                              >
                                By Revenue
                              </MenuItem>
                              <MenuItem
                                onClick={() => updateOperation("rating")}
                              >
                                By Rating
                              </MenuItem>
                              <MenuItem
                                onClick={() => updateOperation("trainees")}
                              >
                                By Trainees
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        </Flex>
                        <Flex
                          color="#616161"
                          fontWeight="600"
                          fontSize="16px"
                          mb="20px"
                          pb="12px"
                          borderBottom="1px solid"
                          borderColor="lightgray"
                          justifyContent="space-between"
                        >
                          <Text>Courses</Text>
                          {operation === "revenue" ? (
                            <Text>Amount</Text>
                          ) : (
                            <Text>#No</Text>
                          )}
                        </Flex>
                        <Box>
                          {currentFilter &&
                            currentFilter.slice(0, 6).map((each, index) => (
                              <Flex
                                mb="20px"
                                key={index}
                                color="#616161"
                                fontSize="16px"
                                justifyContent="space-between"
                              >
                                <Text
                                  width={"70%"}
                                  fontWeight={"500"}
                                  fontSize={"14px"}
                                  textTransform={"capitalize"}
                                >
                                  {each.name.toLowerCase()}
                                </Text>
                                {operation === "revenue" ? (
                                  <Text>
                                    {" "}
                                    <NumericFormat
                                      value={each.value}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"₦"}
                                    />
                                  </Text>
                                ) : (
                                  <Text>{each.value}</Text>
                                )}
                              </Flex>
                            ))}
                        </Box>
                      </Box>
                    </Flex>
                    <Flex
                      justifyContent="space-between"
                      mt="20px"
                      flexDirection={["column", "column", "column", "row"]}
                      gap="1rem"
                    >
                      <Box
                        bg="white"
                        px="20px"
                        width={["100%", "100%", "100%", "60%"]}
                        boxShadow={"sm"}
                      >
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          py="26px"
                        >
                          <Box color="#2B2B2B" fontWeight="800" fontSize="22px">
                            Trainee Gamification
                          </Box>
                        </Flex>
                        <Box height="300px" width="100%">
                          <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                              width={500}
                              height={300}
                              data={data}
                              margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                              }}
                            >
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar dataKey="count" fill="#EC3337" />
                            </BarChart>
                          </ResponsiveContainer>
                        </Box>
                      </Box>
                      <Box
                        bg="white"
                        px="20px"
                        width={["100%", "100%", "100%", "40%"]}
                        boxShadow={"sm"}
                      >
                        <Flex
                          color="#616161"
                          fontWeight="600"
                          fontSize="16px"
                          mb="20px"
                          py="26px"
                          borderBottom="1px solid"
                          borderColor="lightgray"
                          justifyContent="space-between"
                        >
                          <Text>Trainee</Text>
                          {operation === "revenue" ? (
                            <Text>Amount</Text>
                          ) : (
                            <Text>#Badge Count</Text>
                          )}
                        </Flex>
                        <Box>
                          <Flex
                            mb="20px"
                            color="#616161"
                            fontSize="16px"
                            justifyContent="space-between"
                          >
                            <Text
                              width={"70%"}
                              fontWeight={"500"}
                              fontSize={"16px"}
                              textTransform={"capitalize"}
                            >
                              {"Muili Bolaji"}
                            </Text>

                            <Text>{"10"}</Text>
                          </Flex>
                          <Flex
                            mb="20px"
                            color="#616161"
                            fontSize="16px"
                            justifyContent="space-between"
                          >
                            <Text
                              width={"70%"}
                              fontWeight={"500"}
                              fontSize={"16px"}
                              textTransform={"capitalize"}
                            >
                              {"Muili Bolaji"}
                            </Text>

                            <Text>{"10"}</Text>
                          </Flex>

                          <Flex
                            mb="20px"
                            color="#616161"
                            fontSize="16px"
                            justifyContent="space-between"
                          >
                            <Text
                              width={"70%"}
                              fontWeight={"500"}
                              fontSize={"16px"}
                              textTransform={"capitalize"}
                            >
                              {"Muili Bolaji"}
                            </Text>

                            <Text>{"10"}</Text>
                          </Flex>

                          <Flex
                            mb="20px"
                            color="#616161"
                            fontSize="16px"
                            justifyContent="space-between"
                          >
                            <Text
                              width={"70%"}
                              fontWeight={"500"}
                              fontSize={"16px"}
                              textTransform={"capitalize"}
                            >
                              {"Muili Bolaji"}
                            </Text>

                            <Text>{"10"}</Text>
                          </Flex>

                          <Flex
                            mb="20px"
                            color="#616161"
                            fontSize="16px"
                            justifyContent="space-between"
                          >
                            <Text
                              width={"70%"}
                              fontWeight={"500"}
                              fontSize={"16px"}
                              textTransform={"capitalize"}
                            >
                              {"Muili Bolaji"}
                            </Text>

                            <Text>{"10"}</Text>
                          </Flex>

                          <Flex
                            mb="20px"
                            color="#616161"
                            fontSize="16px"
                            justifyContent="space-between"
                          >
                            <Text
                              width={"70%"}
                              fontWeight={"500"}
                              fontSize={"16px"}
                              textTransform={"capitalize"}
                            >
                              {"Muili Bolaji"}
                            </Text>

                            <Text>{"10"}</Text>
                          </Flex>
                        </Box>
                      </Box>
                    </Flex>
                  </TabPanel>
                  <TabPanel>
                    <Flex justifyContent="space-between" pb="20px" mb="20px">
                      <Box bg="white" px="20px" width="100%" boxShadow={"sm"}>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          py="26px"
                        >
                          <Box color="#2B2B2B" fontWeight="800" fontSize="22px">
                            Traffic
                          </Box>

                          <HStack>
                            <Menu>
                              <MenuButton
                                as={Button}
                                // leftIcon={<US title="Nigeria" />}
                                bg="whiteAlpha.200"
                                color="#616161"
                                variant={"outline"}
                                size="sm"
                                fontSize={13}
                                width="106px"
                                border="1px solid"
                                borderColor="#9E9E9E"
                              >
                                2022/2023
                              </MenuButton>
                              <MenuList fontSize={12}>
                                <MenuItem>2022/2023</MenuItem>

                                <MenuItem>2021/2022</MenuItem>
                                <MenuItem> 2020/2021</MenuItem>
                                <MenuItem>2019/2020</MenuItem>
                              </MenuList>
                            </Menu>
                          </HStack>
                        </Flex>
                        <Box height="300px" width="100%">
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart
                              width={500}
                              height={300}
                              data={data2}
                              margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                              }}
                            >
                              <CartesianGrid strokeDasharray="0 2" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Line
                                type="monotone"
                                dataKey="uv"
                                stroke="#EC3337"
                              />
                            </LineChart>
                          </ResponsiveContainer>
                        </Box>
                      </Box>
                    </Flex>

                    <Flex
                      justifyContent="space-between"
                      mt="20px"
                      width={"100%"}
                      gap={"1rem"}
                      flexDirection={["column", "column", "column", "row"]}
                    >
                      <Box
                        bg="white"
                        px="20px"
                        // borderRadius={8}
                        boxShadow="sm"
                        width={["100%", "100%", "100%", "60%"]}
                      >
                        {" "}
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          py="26px"
                        >
                          <Box color="#2B2B2B" fontWeight="800" fontSize="24px">
                            Overall Traffic
                          </Box>
                        </Flex>
                        <Text
                          color="#959595"
                          fontWeight="400"
                          fontSize="14px"
                          mt={2}
                          mb={4}
                        >
                          Visits in the past 365 days
                        </Text>
                        <ResponsiveContainer width="100%" height={400}>
                          <Chart
                            chartType="PieChart"
                            data={trafficconditionPiechartData}
                            options={traffic_condition_options_piechart}
                          />
                        </ResponsiveContainer>
                      </Box>

                      <Box
                        bg="white"
                        px="20px"
                        width={["100%", "100%", "100%", "40%"]}
                        boxShadow={"sm"}
                      >
                        <Grid
                          templateColumns="repeat(3, 1fr)"
                          gap={2}
                          color="#616161"
                          fontWeight="600"
                          fontSize="15px"
                          mb="20px"
                          py="22px"
                          borderBottom="1px solid"
                          borderColor="lightgray"
                          width={"100%"}
                        >
                          <GridItem w="100%" h="8">
                            City
                          </GridItem>
                          <GridItem w="100%" h="8">
                            Visits
                          </GridItem>
                          <GridItem w="100%" h="8" isTruncated>
                            Avg. Engagement Time
                          </GridItem>
                        </Grid>
                        <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                          {cityDataArray.map((cityInfo, index) => {
                            return (
                              <React.Fragment key={index}>
                                <GridItem w="100%" h="8">
                                  {cityInfo.city}
                                </GridItem>
                                <GridItem w="100%" h="8">
                                  {cityInfo.totalUsers}
                                </GridItem>
                                <GridItem w="100%" h="8">
                                  {cityInfo.averageEngagementTime}
                                </GridItem>
                              </React.Fragment>
                            );
                          })}
                        </Grid>
                      </Box>
                    </Flex>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default AdminReports;
